module.exports = __webpack_public_path__ + "img/icon_ahorro_black.bf16f85b.svg";